// Copyright 2020-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React, { useState } from 'react';
import {
  ControlBar,
  AudioInputVFControl,
  AudioInputControl,
  ContentShareControl,
  AudioOutputControl,
  ControlBarButton,
  useUserActivityState,
  Dots,
  VideoInputControl,
  Feedback
} from 'amazon-chime-sdk-component-library-react';

import EndMeetingControl from '../EndMeetingControl';
import { useNavigation } from '../../providers/NavigationProvider';
import { StyledControls } from './Styled';
import { useAppState } from '../../providers/AppStateProvider';
import { VideoFiltersCpuUtilization } from '../../types';
import VideoInputTransformControl from '../../components/MeetingControls/VideoInputTransformControl';

const MeetingControls: React.FC = () => {
  const { toggleNavbar, closeRoster, showRoster, showCaption, toggleCaption, showIndoCaption, toggleIndoCaption } = useNavigation();
  const { isUserActive } = useUserActivityState();
  const { isWebAudioEnabled, videoTransformCpuUtilization } = useAppState();
  const videoTransformsEnabled = videoTransformCpuUtilization !== VideoFiltersCpuUtilization.Disabled;

  const handleToggle = (): void => {
    if (showRoster) {
      closeRoster();
    }
    toggleNavbar();
  };

  const handleCaption = (): void => {
    toggleCaption();
    if(showIndoCaption){
      toggleIndoCaption();
    }
  };

  const handleIndoCaption = async () => {
    toggleIndoCaption();
    if(showCaption){
      toggleCaption();
    }
  };

  return (
    <StyledControls className="controls" active={!!isUserActive}>
      <ControlBar
        className="controls-menu"
        layout="undocked-horizontal"
        showLabels
      >
        <ControlBarButton
          className="mobile-toggle"
          icon={<Dots />}
          onClick={handleToggle}
          label="Menu"
        />
        { isWebAudioEnabled ? <AudioInputVFControl /> :  <AudioInputControl /> }
        { videoTransformsEnabled ? <VideoInputTransformControl /> : <VideoInputControl/> }
        {/* <ContentShareControl /> */}
        <ControlBarButton
          className="caption-toggle"
          icon={<Feedback />}
          onClick={handleCaption}
          label="Caption"
        />
        <ControlBarButton
          className="caption-indo-toggle"
          icon={<Feedback />}
          onClick={handleIndoCaption}
          label="Caption (Indo)"
        />
        <AudioOutputControl />
        <EndMeetingControl />
      </ControlBar>
    </StyledControls>
  );
};

export default MeetingControls;
